import VpnKeyIcon from '@mui/icons-material/VpnKey'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { useEffect, useState, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default function CheckboxList({
	enableIcon = false,
	enableCheckbox = true,
	onIconClick,
	checkedIconList,
	title,
	data,
	onItemClick,
	checkedList,
	getLabel,
	getValue,
	checkboxColor = 'primary',
	hideScroll,
	defaultChecked,
	onChange,
	marginTopTitle,
	enableCheckAll = false,
	handleSettingsChange = () => {},
}) {
	const [t] = useTranslation('common')
	const allValues = useMemo(() => {
		return data?.map((o) => getValue(o)) || []
	}, [data])
	const handleCheckAll = (e) => {
		if (e.target.checked) {
			handleSettingsChange('columnsChecked', allValues)
		} else {
			handleSettingsChange('columnsChecked', [])
		}
	}
	const buildCheckboxList = useCallback(() => {
		return (
			<List
				sx={{
					width: '100%',
					// minHeight: heightValue,
					maxHeight: 180,
					overflowY: hideScroll === true ? 'none' : 'scroll',
					border: '1px solid #ddd',
					borderRadius: 1,
					mb: 2,
					marginTop: `0 !important`,
				}}
				dense
			>
				{data?.length === 0 && <Typography px={2}>{t('common:dis.emptyFields')}</Typography>}
				{data?.length > 0 &&
					data.map((option) => {
						if (option && option?.hide) {
							return null
						}

						const labelId = `checkbox-list-label-${option.value}`
						const optionValue = getValue(option)
						const isNickname = optionValue === 'Nickname'
						const isMobileNumber = optionValue === 'Mobile_number'
						const isDefaultChecked = isMobileNumber && (!checkedList || checkedList.length === 0)
						const isChecked = isNickname || isDefaultChecked || checkedList?.includes(optionValue)
						return (
							<ListItem
								key={optionValue}
								disablePadding
								sx={{
									'& .MuiButtonBase-root': {
										py: '2px',
									},
								}}
							>
								<ListItemButton
									role={undefined}
									disabled={option?.disableOption}
									onClick={onItemClick(optionValue)}
									dense
									sx={{
										'& .MuiListItemIcon-root': {
											minWidth: '15px !important',
										},
									}}
								>
									{enableIcon && (
										<Tooltip title={t('common:dis.makeKey')} placement="right">
											<IconButton
												edge="start"
												aria-label="comments"
												size="small"
												sx={{ mr: 1 }}
												onClick={(e) => {
													e.stopPropagation()

													onIconClick?.(optionValue)
												}}
											>
												<VpnKeyIcon
													fontSize="small"
													color={
														checkedIconList?.indexOf(optionValue) !== -1 ? 'primary' : 'inherit'
													}
												/>
											</IconButton>
										</Tooltip>
									)}
									<ListItemText id={labelId} primary={getLabel(option)} />
									{enableCheckbox && (
										<ListItemIcon>
											<Checkbox
												edge="end"
												checked={isChecked}
												disabled={isNickname}
												tabIndex={-1}
												disableRipple
												color={checkboxColor}
												inputProps={{
													'aria-labelledby': labelId,
												}}
												size="small"
												onChange={(e) => {
													e.stopPropagation()
													onChange && onChange(e.target.checked, optionValue)
												}}
											/>
										</ListItemIcon>
									)}
								</ListItemButton>
							</ListItem>
						)
					})}
			</List>
		)
	}, [
		hideScroll,
		data,
		t,
		getValue,
		checkedList,
		onItemClick,
		enableIcon,
		checkedIconList,
		getLabel,
		enableCheckbox,
		checkboxColor,
		onIconClick,
	])

	return (
		<>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					pl: 1,
					pr: 1,
					mb: 0.5,
				}}
			>
				<Typography
					variant="subtitle2"
					sx={{ pl: 1, marginTop: marginTopTitle ? null : '0 !important' }}
				>
					{title}
				</Typography>
				{enableCheckAll && (
					<Box display="flex" alignItems="center" gap={0.5} marginRight={'13px'}>
						<Typography variant="body2">All</Typography>
						<Checkbox
							size="small"
							checked={checkedList?.length === data?.length}
							onChange={(e) => {
								handleCheckAll(e)
							}}
						/>
					</Box>
				)}
			</Box>
			{buildCheckboxList()}
		</>
	)
}
